import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { PortalTopPart, PortalTwoColumnLayout } from 'components/PortalStructure';
import { manageShopLinksAdmin, manageShopLinksMember } from 'models/shop/manageshop';
import { Link, PlainRoute } from 'react-router';
import { IShopProfile } from 'models/shop/shopprofile';
import { IShopCard } from 'models/shop/shopcard';
import Helmet from 'react-helmet';
import { IStore } from 'redux/IStore';
import { Dispatch } from 'redux';
import { IUserPreferences } from 'models/user/userpreferences';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { isAdmin, isPlatformAdmin } from 'redux/modules/shop/helpers';
const { connect } = require('react-redux');

interface IProps {
	route?: PlainRoute;
	id?: string;
	shop?: IShopProfile | IShopCard;
	mobileDropdownMenuTitle?: string;
	t?: (key: string) => string;
	userPreferences?: IUserPreferences;
}

type ReduxProps = ReturnType<typeof stateToProps> & ReturnType<typeof dispatchToProps>;

const isShopCard = (c: IProps['shop']): c is IShopCard => c && 'picture' in c;

@connect((state: IStore) => {
	return {
		userPreferences: state.userPreferences,
	};
})
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageShopWrapperComponent extends React.Component<IProps & ReduxProps, {}> {
	public componentDidMount(): void {
		this.fetchShopCard();
	}
	public componentDidUpdate(): void {
		this.fetchShopCard();
	}

	private fetchShopCard() {
		if (!isShopCard(this.props.shop) && !isShopCard(this.props.shopCard)) {
			this.props.getShopCard(this.props.id);
		}
	}

	private get shopCard(): IShopCard | undefined {
		if (isShopCard(this.props.shop)) {
			return this.props.shop;
		}
		if (isShopCard(this.props.shopCard)) {
			return this.props.shopCard;
		}
	}

	public render() {
		const { t, id, shop, shopCard, route, userPreferences } = this.props;
		const shopId = shop?.id || shopCard?.id;
		const manageShopLinks =
			isAdmin(shopId, userPreferences.userRoles) || isPlatformAdmin(userPreferences)
				? manageShopLinksAdmin
				: manageShopLinksMember;
		const pathParts = (route?.path || '').split('/').filter(Boolean);
		const slug = pathParts.length ? pathParts[pathParts.length - 1] : '';

		const activeLinkTitle = manageShopLinks.find((msl) => msl.slug === slug)?.title;
		const leftMenu = (
			<div className="sidemenu">
				<ul>
					{manageShopLinks &&
						manageShopLinks
							.filter((x) => x.inSettings === true)
							.map((msl) => (
								<li key={msl.slug}>
									<Link activeClassName="active" to={`/shop/${id}/${msl.slug}`}>
										{t(msl.title)}
									</Link>
								</li>
							))}
				</ul>
			</div>
		);

		const titleParts = [shop?.name || shopCard?.name, activeLinkTitle ? t(activeLinkTitle) : null].filter(Boolean);

		return (
			<>
				<Helmet title={titleParts.join(': ')} />
				<PortalTopPart item={this.shopCard} type="shop" />
				<PortalTwoColumnLayout className="manageShop" sideMenu={leftMenu}>
					<br />
					{this.props.children}
				</PortalTwoColumnLayout>
			</>
		);
	}
}

const stateToProps = (state: IStore, ownProps: IProps) => ({
	shopCard: ownProps.id && state.shopcard?.shopcard?.id === ownProps.id ? state.shopcard.shopcard : undefined,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	getShopCard: (id: string) => dispatch(getShopCard(id, false)),
});

const ManageShopWrapper = connect(stateToProps, dispatchToProps)(ManageShopWrapperComponent);

export { ManageShopWrapper };
